import { eye } from "@assets/icons";
import SubscriptionCard from "@commons/cards/subscription";
import TransactionCard from "@commons/cards/transaction";
import Header from "@commons/header";
import Column from "@components/column";
import DropDown from "@components/fields/dropdown";
import Row from "@components/row";
import Table from "@components/table";
import { Form, Formik } from "formik";
import { Store } from "lucide-react";
import React from "react";

const SubscriberList = () => {
  const columns = [
    { title: "SN", key: "sn" },
    { title: "Store Info", key: "storeInfo" },
    { title: "Current Package Name", key: "packageName" },
    { title: "Package Price", key: "packagePrice" },
    { title: "Exp Date", key: "expDate" },
    { title: "Total Subscription", key: "totalSubscription" },
    {
      title: "is Trial",
      key: "isTrial",
      render: (item) => <p>{item.isTrial ? "Yes" : "No"}</p>,
    },
    {
      title: "is Cancel",
      key: "isCancel",
      render: (item) => <p>{item.isTrial ? "Yes" : "No"}</p>,
    },
    { title: "Status", key: "status" },
  ];

  // Example data array
  const data = [
    {
      sn: 1,
      storeInfo: "Store A (a@example.com)",
      packageName: "Basic",
      packagePrice: "500",
      expDate: "2025-12-31",
      totalSubscription: 12,
      isTrial: false,
      isCancel: false,
      status: "Active",
    },
    {
      sn: 2,
      storeInfo: "Store B (b@example.com)",
      packageName: "Premium",
      packagePrice: "1500",
      expDate: "2026-03-15",
      totalSubscription: 24,
      isTrial: true,
      isCancel: false,
      status: "Active",
    },
    {
      sn: 3,
      storeInfo: "Store C (c@example.com)",
      packageName: "Standard",
      packagePrice: "1000",
      expDate: "2025-11-20",
      totalSubscription: 18,
      isTrial: false,
      isCancel: true,
      status: "Cancelled",
    },
    {
      sn: 4,
      storeInfo: "Store D (d@example.com)",
      packageName: "Premium",
      packagePrice: "1500",
      expDate: "2026-01-10",
      totalSubscription: 30,
      isTrial: false,
      isCancel: false,
      status: "Active",
    },
  ];

  const subscriptionData = [
    {
      count: "8",
      title: "Total Subscribed User",
      icon: "/pngs/subscription/subscribed-user.png",
      status: "subscribed",
    },
    {
      count: "2",
      title: "Active Subscription",
      icon: "/pngs/subscription/active-user.png",
      status: "active",
    },
    {
      count: "6",
      title: "Expired Subscription",
      icon: "/pngs/subscription/expired-user.png",
      status: "expired",
    },
    {
      count: "0",
      title: "Expiring Soon",
      icon: "/pngs/subscription/expired-soon.png",
      status: "expiring",
    },
  ];

  return (
    <>
      <Column>
        <Row styleRow="align-items:center;justify-content:space-between">
          <Header title="Subscribed Store List" icon={Store} />
          <div style={{ width: "20%", paddingRight: "30px" }}>
            <Formik initialValues={{}} onSubmit={() => {}}>
              <Form>
                <DropDown
                  placeholder="All Zones"
                  hasSearch
                  name="zone"
                  options={[
                    { value: "all", title: "All Zones" },
                    { value: "koteswor", title: "Koteswor" },
                    { value: "baneswor", title: "Baneswor" },
                  ]}
                  titleAsKey="title"
                  valueAsKey="value"
                />
              </Form>
            </Formik>
          </div>
        </Row>
        <Row>
          {subscriptionData.map((item, i) => (
            <SubscriptionCard key={i} item={item} />
          ))}
        </Row>
        <TransactionCard />
        <Table
          text="Store List"
          columns={columns}
          data={data}
          actions={[{ key: "", icon: eye, onClick: () => {} }]}
        />
      </Column>
    </>
  );
};

export default SubscriberList;
